// extracted by mini-css-extract-plugin
export default {"container":"sy-z","brandName":"ty-z","productName":"uy-z","aboveGalleryInfo":"vy-z","belowGalleryInfo":"wy-z","breakLongProductName":"xy-z"};